var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('ProductZoomer',{key:_vm.product.masterData.current.variant.sku,attrs:{"base-images":_vm.zoomerImages,"base-zoomer-options":_vm.zoomerOptions,"data-test":"product-image"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }